
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LinkIcon, UsersIcon, BarChart3Icon, MessageSquareIcon, ShieldIcon, FlagIcon, Upload, Database } from "lucide-react";
import { Link } from 'react-router-dom';
import { LogoManagement } from '@/components/admin/logo/LogoManagement';

const AdminDashboard = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
        <p className="text-muted-foreground mt-1">Central administration panel</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Link to="/admin/affiliate">
          <Card className="hover:shadow-md transition-shadow card-scheme-coral-orange">
            <CardHeader className="border-b">
              <div className="flex items-center justify-between">
                <CardTitle className="text-xl">Affiliate Management</CardTitle>
                <UsersIcon className="h-5 w-5 text-botscheme-coral-orange" />
              </div>
            </CardHeader>
            <CardContent className="pt-4">
              <p className="text-muted-foreground">Manage affiliates, track referrals, and monitor for suspicious activity.</p>
              <div className="mt-4 flex gap-2">
                <span className="text-xs px-2 py-1 bg-botscheme-coral-orange/20 text-botscheme-coral-orange rounded-full">48 Affiliates</span>
                <span className="text-xs px-2 py-1 bg-botscheme-ruby-red/20 text-botscheme-ruby-red rounded-full">3 Flagged Activities</span>
              </div>
            </CardContent>
          </Card>
        </Link>
        
        <Link to="/admin/ai-assistant/management">
          <Card className="hover:shadow-md transition-shadow card-scheme-ocean-blue">
            <CardHeader className="border-b">
              <div className="flex items-center justify-between">
                <CardTitle className="text-xl">AI Assistant</CardTitle>
                <MessageSquareIcon className="h-5 w-5 text-botscheme-ocean-blue" />
              </div>
            </CardHeader>
            <CardContent className="pt-4">
              <p className="text-muted-foreground">Manage AI knowledge base, analyze performance, and optimize responses.</p>
              <div className="mt-4 flex gap-2">
                <span className="text-xs px-2 py-1 bg-botscheme-ocean-blue/20 text-botscheme-ocean-blue rounded-full">Rules Management</span>
                <span className="text-xs px-2 py-1 bg-botscheme-emerald-green/20 text-botscheme-emerald-green rounded-full">Sentiment Analysis</span>
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/tradingview-crawler">
          <Card className="hover:shadow-md transition-shadow card-scheme-emerald-green">
            <CardHeader className="border-b">
              <div className="flex items-center justify-between">
                <CardTitle className="text-xl">TradingView Crawler</CardTitle>
                <Database className="h-5 w-5 text-botscheme-emerald-green" />
              </div>
            </CardHeader>
            <CardContent className="pt-4">
              <p className="text-muted-foreground">Crawl and analyze market ideas from TradingView for various trading pairs.</p>
              <div className="mt-4 flex gap-2">
                <span className="text-xs px-2 py-1 bg-botscheme-emerald-green/20 text-botscheme-emerald-green rounded-full">Market Analysis</span>
                <span className="text-xs px-2 py-1 bg-botscheme-ocean-blue/20 text-botscheme-ocean-blue rounded-full">Data Collection</span>
              </div>
            </CardContent>
          </Card>
        </Link>
      </div>

      {/* Logo Management Section */}
      <div className="grid grid-cols-1 gap-6">
        <LogoManagement />
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle>Quick Links</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Link to="/admin/affiliate/affiliates" className="flex items-center gap-2 p-3 border rounded-md hover:bg-muted transition-colors">
              <UsersIcon className="h-5 w-5 text-botscheme-coral-orange" />
              <span>Manage Affiliates</span>
            </Link>
            
            <Link to="/admin/affiliate/tracking" className="flex items-center gap-2 p-3 border rounded-md hover:bg-muted transition-colors">
              <BarChart3Icon className="h-5 w-5 text-botscheme-ocean-blue" />
              <span>Referral Tracking</span>
            </Link>
            
            <Link to="/admin/affiliate/flagged" className="flex items-center gap-2 p-3 border rounded-md hover:bg-muted transition-colors">
              <FlagIcon className="h-5 w-5 text-botscheme-ruby-red" />
              <span>Flagged Activity</span>
            </Link>
            
            <Link to="/admin/ai-assistant/management" className="flex items-center gap-2 p-3 border rounded-md hover:bg-muted transition-colors">
              <MessageSquareIcon className="h-5 w-5 text-botscheme-ocean-blue" />
              <span>AI Management</span>
            </Link>
            
            <Link to="/admin/ai-assistant/analytics" className="flex items-center gap-2 p-3 border rounded-md hover:bg-muted transition-colors">
              <BarChart3Icon className="h-5 w-5 text-botscheme-emerald-green" />
              <span>AI Analytics</span>
            </Link>

            <Link to="/admin/logo-management" className="flex items-center gap-2 p-3 border rounded-md hover:bg-muted transition-colors">
              <Upload className="h-5 w-5 text-botscheme-emerald-green" />
              <span>Logo Management</span>
            </Link>

            <Link to="/admin/tradingview-crawler" className="flex items-center gap-2 p-3 border rounded-md hover:bg-muted transition-colors">
              <Database className="h-5 w-5 text-botscheme-emerald-green" />
              <span>TradingView Crawler</span>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminDashboard;
